import { createContext } from "react";

export const LayoutContext = createContext<{ title: string; setTitle: (title: string) => void }>({
  title: "",
  setTitle: () => {},
});

export default LayoutContext;
